<template>
  <div class="content-list">
    <ul class="content-list__ul">
      <ContentRow
        v-for="item in items"
        :key="item.objectID"
        :content="item"
        :searchIndex="searchIndex"
        :openInNewTab="openInNewTab"
        @open-video="openVideo"
      />
    </ul>
    <VideoModal
      v-if="videoProps.video"
      v-bind="videoProps"
      @close-video-player="closeVideo"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ContentRow from '@/components/search/content-rows/ContentRow.vue'
import VideoModal from '@/components/search/VideoModal.vue'

export default {
  name: 'ContentList',
  components: {
    ContentRow,
    VideoModal,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    searchIndex: {
      type: Object,
      required: false,
    },
    openInNewTab: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => {
    return {
      videoProps: { video: null, parents: [] },
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('labs/getRunningLab')
    }
    this.$store.dispatch('courses/getActiveCourses')
  },
  methods: {
    ...mapMutations({
      setParentContent: 'content/CURRENT_PARENT',
    }),
    openVideo(payload) {
      if (this.isAuthenticated) {
        const { parents } = payload

        if (parents.length) {
          const fisrtParent = parents[0]

          this.setParentContent({
            id: fisrtParent.objectID,
            type: fisrtParent.content_type,
          })
        }
        this.videoProps = payload
      } else {
        this.$store.dispatch('app/setError', 'Please login to watch this video')
      }
    },
    closeVideo() {
      this.videoProps = { video: null, parents: [] }
    },
  },
}
</script>

<style lang="scss" scoped>
.content-list {
  &__ul {
    display: flex;
    row-gap: 10px;
    flex-flow: column;
    margin: 0;
    padding: 0;
  }
}
</style>
